import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-simple-primary",
  "use": "icon-arrow-right-simple-primary-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right-simple-primary\">\n<path d=\"M0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0L0 1.41Z\" fill=\"#0747A6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol